import { useEffect } from "react";
import { SITE_URL, LOCAL_BUSINESS_SCHEMA } from "@/data/site";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, obj) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

// Per-page SEO: title, meta description, canonical, Open Graph + JSON-LD.
// extraSchema: array of JSON-LD objects (Service, BreadcrumbList, FAQPage...).
// businessExtra: fields merged into the LocalBusiness schema (e.g. aggregateRating, review).
export const Seo = ({ title, description, path = "/", extraSchema = [], businessExtra = null, noindex = false }) => {
  const extraKey = JSON.stringify(extraSchema);
  const bizKey = JSON.stringify(businessExtra);
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertLink("canonical", url);
    upsertJsonLd("ld-localbusiness", { ...LOCAL_BUSINESS_SCHEMA, url, ...(businessExtra || {}) });

    document.querySelectorAll("script[data-ld-extra]").forEach((e) => e.remove());
    extraSchema.forEach((obj) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-ld-extra", "");
      el.textContent = JSON.stringify(obj);
      document.head.appendChild(el);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, extraKey, bizKey, noindex]);

  return null;
};
